/* eslint-disable no-unused-vars */
import { styled } from "@mui/material";
import { DataGridPremium } from "@mui/x-data-grid-premium";

const CustomizedDataGridPremium = styled(DataGridPremium)(({ theme, customStyles, customClasses }) => ({
	...customStyles?.root,

	"&.MuiDataGrid-root.MuiDataGrid-root--densityStandard.MuiDataGrid-root--noToolbar.MuiDataGrid-withBorderColor": {
		border: "none !important",
		outline: "none !important"
	},
	"&. MuiDataGrid-columnHeader:focus-within": {
		border: "none !important",
		outline: "none !important"
	},
	"& .MuiDataGrid-cell:focus-within": {
		border: "none !important",
		outline: "none !important"
	},
	"& .MuiDataGrid-scrollbarFiller": {
		border: "none !important",
		outline: "none !important"
	},
	"& .MuiDataGrid": {
		border: "none !important",
		outline: "none !important"
	},
	"& .MuiDataGrid-column": {
		border: "none !important",
		outline: "none !important"
	},
	"& .MuiPaper-root-MuiDrawer-paper": {
		border: "none !important",
		outline: "none !important"
	},
	"& .MuiDataGrid-row": {
		...customStyles?.muiDataGridRow,
		cursor: "pointer",
		border: "none !important",
		outline: "none !important",
		fontSize: customStyles?.muiDataGridRow?.fontSize || "10px !important" // Applied dynamic font size
	},
	"& .MuiDataGrid-overlayWrapperInner": {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	"& .MuiDataGrid-footerContainer.MuiDataGrid-withBorderColor": {
		border: "none !important",
		outline: "none !important",
		display: "none !important"
	},

	"& .MuiDataGrid-filler, & .MuiDataGrid-columnSeparator": {
		display: "none !important"
	},
	"& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
		border: customStyles?.muiDataGridCellAndColumnHeader?.border || "unset !important",
		fontSize: customStyles?.muiDataGridCellAndColumnHeader?.fontSize || "10px !important", // Applied dynamic font size
		color: customStyles?.muiDataGridCellAndColumnHeader?.color || "#979798", // Applied dynamic color,
		...customStyles?.muiDataGridCellAndColumnHeader
	},
	"& .MuiDataGrid-columnHeader": {
		backgroundColor: customStyles?.muiDataGridColumnHeaders?.backgroundColor || "#2C2D2F !important", // Applied dynamic background color
		fontSize: customStyles?.muiDataGridColumnHeaders?.fontSize || "10px !important", // Applied dynamic font size
		color: customStyles?.muiDataGridColumnHeaders?.color || "#979798" // Applied dynamic color
	},
	"& .MuiDataGrid-row--firstVisible .group-column-cell": {
		width: "300px !important"
	},
	"& .MuiDataGrid-row--firstVisible div": {
		borderTop: "unset !important"
	},
	'& [dir="ltr"] .MuiDataGrid-groupingCriteriaCellToggle': {
		marginRight: "7px"
	},
	'& [dir="rtl"] .MuiDataGrid-groupingCriteriaCellToggle': {
		marginLeft: "7px"
	},
	"& .MuiDataGrid-cell.MuiDataGrid-cell--textLeft": {
		...customStyles.muiDataGridCellTextLeft
	},
	"& .MuiDataGrid-row Mui-selected MuiDataGrid-row--firstVisible": {
		...customStyles.muiDataGridRowMuiSelectedMuiDataGridRowFirstVisible
	},
	"& .MuiDataGrid-row.MuiDataGrid-row--firstVisible": {
		...customStyles.muiDataGridRowMuiDataGridRowFirstVisible
	},
	"& .MuiDataGrid-row:hover": {
		...customStyles.muiDataGridRowHover
	},
	"& .MuiDataGrid-row.Mui-selected": {
		...customStyles.muiDataGridRowMuiSelected
	},
	"& .MuiDataGrid-row.Mui-selected:hover": {
		...customStyles.muiDataGridSelectedRowHover
	},
	...customClasses
}));

export default CustomizedDataGridPremium;
